import React, { useEffect } from 'react'
import PropTypes from 'prop-types';
// import clsx from 'clsx';
import axios from 'axios'
import { connect } from 'react-redux'
import { fade, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Chip from '@material-ui/core/Chip';
import AdbIcon from '@material-ui/icons/Adb';
import { Button, CircularProgress }  from '@material-ui/core';
import Grid from '@material-ui/core/Grid'
// import Toolbar from '@material-ui/core/Toolbar';
// import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
// import Checkbox from '@material-ui/core/Checkbox';
// import IconButton from '@material-ui/core/IconButton';
// import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import AddIcon from '@material-ui/icons/AddCircle';
// import FilterListIcon from '@material-ui/icons/FilterList';
import moment from 'moment'
import { Link } from 'react-router-dom'
// import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { socket } from '../SocketIo/Socket'
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import EquipmentModal from './EquipmentModal'
import AddEquipmentModal from './AddEquipmentModal'
import ChooseEntityComponent from '../Entities/ChooseEntityComponent'
import { formatPhoneNumber } from '../../services/common'
import { useHistory } from "react-router-dom"
// function createData(name, status, created, lastactivity, tourbooked) {
//   return { name, status, created, lastactivity, tourbooked };
// }

// const rows = [
//   createData('Tom Smith', 'New', '12/17/2019', null, null),
//   createData('Donut', 'Working', '12/18/2019', 51, 4.9),
//   createData('Eclair', 'New', '11/29/2019', 24, 6.0),
//   createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
//   createData('Gingerbread', 356, 16.0, 49, 3.9),
//   createData('Honeycomb', 408, 3.2, 87, 6.5),
//   createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
//   createData('Jelly Bean', 375, 0.0, 94, 0.0),
//   createData('KitKat', 518, 26.0, 65, 7.0),
//   createData('Lollipop', 392, 0.2, 98, 0.0),
//   createData('Marshmallow', 318, 0, 81, 2.0),
//   createData('Nougat', 360, 19.0, 9, 37.0),
//   createData('Oreo', 437, 18.0, 63, 4.0),
// ];

function desc(a, b, orderBy, isDate) {
  // console.log('desc: ', a)
  // console.log('desc b: ', b)
  if (isDate) {
    if (b[orderBy] < a[orderBy] || b[orderBy] == null) {
      // console.log('B is < A')
      return -1;
    }
    if (b[orderBy] > a[orderBy] || a[orderBy] == null) {
      // console.log('B is > A')
      return 1;
    }
    // console.log('B is ? A')
    // console.log('A: ', a[orderBy])
    // console.log('B: ', b[orderBy])
    return 0;
  } else {
    if (b[orderBy] < a[orderBy] || b[orderBy] == null) {
      return -1;
    }
    if (b[orderBy] > a[orderBy] || a[orderBy] == null) {
      return 1;
    }
    return 0;
  }
}

function stableSort(array, cmp) {
  // console.log('Stable sort: ', array.length)
  // console.log('CMP: ', cmp)
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  // console.log('Matches: ', stabilizedThis.length)
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  if (orderBy==='lastUpdated') {
  // console.log('Last Updated')
    return order === 'desc' ? (a, b) => desc(a, b, orderBy, true) : (a, b) => -desc(a, b, orderBy, true);
  } else {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
  }
  
}

const headCells = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Name' },
  { id: 'entity', numeric: false, disablePadding: false, label: 'Entity' },
  { id: 'type', numeric: false, disablePadding: true, label: 'Type' },
  { id: 'location', numeric: false, disablePadding: false, label: 'Location' },
  { id: 'crewName', numeric: false, disablePadding: false, label: 'Crew' },
  { id: 'division', numeric: false, disablePadding: false, label: 'Division' },
  { id: 'details', numeric: false, disablePadding: false, label: 'Details' },
  { id: 'pictureURL', numeric: false, disablePadding: false, label: 'Photo'}
];

function EnhancedTableHead(props) {
// console.log('Got our props', props)
  
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
  // console.log('Sort Property: ', property)
  // console.log('sort event; ', event)
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all leads' }}
          />
        </TableCell> */}
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={order}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fakeLink: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: 'blue'
  },
  rowPad: {
    height: '40px !important',
    // padding: 'px'
  }
}));

function EnhancedTable(props) {
  const history = useHistory();
// console.log('Equipment  List Props: ', props)
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('-created');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [searchValue, setsearchValue] = React.useState('');
  const [searchMatches, setsearchMatches] = React.useState(0);
  const [open, setOpen] = React.useState(false)
  const [snoutWeevilModalOpen, setSnoutWeevilModalOpen] = React.useState(false)
  const [equipment, setEquipment] = React.useState({});
  // const [svcModalOpen, setOpen] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [showAllEquipment, setShowAllEquipment] = React.useState(false)
  const [rows, setRows] = React.useState([])
  const [filteredRows, setFilteredRows] = React.useState([])
  const [crews, setCrews] = React.useState([])
  const [state, setState] = React.useState({
    searchMatches: 0,
    openSnoutWeevil: false
  })
  const [showNewEquipmentModal, setShowNewEquipmentModal] = React.useState(false)
  const [equipmentTypes, setEquipmentTypes] = React.useState([])
  const [jobSites, setJobSites] = React.useState([])
  // const [leads, setLeads] = React.useState([]);
  // setLeads(props.leads)
  // let clients  = []
  // if (clients && clients.length > 0) clients = props.clients
  // console.log('Clients on table: ', clients)
  // const rows = leads
 
  // setRows(leads)
  // setRows(leads)
  // useEffect(() => {
  // // console.log('Use effect LEADS', leads)
  //   axios
  //     .get(
  //       `${url}/api/tours/getAll`
  //       )
  //     .then(({ data }) => {
  //     // console.log(data)
  //       setLeads(data)
  //     }).catch(function (err) {
  //     // console.log('Error getting stuff', err)
  //     });
  // }, [leads]);
  const fetchJobSites = async (toReturn, entityToUse) => {
    console.log('fetchJobsites', jobSites)

    try {
      console.log('Lets get em boys')
      const resp = await axios.get(`${props.url}/api/hmi/genericGetRequest?type=ACTIVE_JOBSITES&entity=${entityToUse}`)
      console.log('263 resp fetchJobSites', resp)
      if (resp?.data?.data?.length) {
        console.log('Got some jobsites', resp.data)
        setJobSites(resp.data.data)
      }
       
    } catch (e) {
      console.lg('273 afetch jobsites error', e)
    } finally {
      console.log('donezo...')
      setLoading(false)
    }

  }

  async function fetchData(toReturn, entityToUse) {
  // console.log('Fetch our services')
    setLoading(true)
    setRows([])
    setFilteredRows([])
    const response = await axios.get(`${props.url}/api/equipment/listEquipment?entity=${entityToUse}`)
  console.log(response)
    if (response.data && response.data.equipment) {
    console.log('Got Equipment!!', response.data)
        setLoading(false)
        if (showAllEquipment) {
          setRows(response.data.equipment)
          setFilteredRows(response.data.equipment)
          setCrews(response.data.crews)
        } else {
          let activeGear = response.data.equipment.filter(item => { return item.isActive })
          // console.log('Got %d activeClients: ', activeClients.length)
          setFilteredRows(activeGear)
          setRows(response.data.equipment)
          setCrews(response.data.crews)
        }
        if (props.match?.params?.equipmentId) {
          let newRows = response.data.equipment || []
          const equipmentId = props.match.params.equipmentId
          console.log('We have equipment to open...', equipmentId)
          if (newRows.length) {
            console.log('rows.', newRows)
            let item = [...newRows].find(row => (row?._id?.toString() === equipmentId.toString()))
            if (item._id) {
              console.log('found it', item)
              openSvcModal(item)
            }
          }
        }
    } else {
    // console.log('Fucked up')
    }
  }


  useEffect(() => {
    console.log('Props.match changed...', props)
    if (props?.match?.params?.equipmentId) {
      const equipmentId = props.match.params.equipmentId
      console.log('We have equipment to open...', equipmentId)
      if (rows.length) {
        console.log('rows.', rows)
        let item = [...rows].find(row => (row?._id?.toString() === equipmentId.toString()))
        if (item._id) {
          console.log('found it', item)
          openSvcModal(item)
        }
      } else {
        console.log('hang tight...')
      }


    }
  }, [props.match])

  useEffect(() => {
    // console.log('Check if we have anything in our params??', props.match)
    // Fetch equipment types from the backend
    axios
      .get(`${props.url}/api/settings/equipmentTypes`)
      .then((response) => {
        let equipmentTypesArray = response.data.map(item => (item.type))
        setEquipmentTypes(equipmentTypesArray);
      })
      .catch((error) => {
        props.notification({ title: 'Error', message: 'Failed to fetch equipment types', type: 'error' });
      });
  }, []);

  React.useEffect(() => {
  // console.log('Use effectset Equipment list: ', props.clients)
    fetchData(null, 'All')
    fetchJobSites(null, 'All')
  }, [])

  React.useEffect(() => {

      socket.on(`equipupdates`, function (msg) {
        // console.log('Do we have rows??', rows)
        // console.log('GOT A SOCKET MESSAGE EQUIPMENT UPDATE: ', msg)
        if (msg.type) {
          if (msg.type === 'checkOut') {
            if (msg.equipmentId) {
              if (msg.updatedItem) {
                // console.log('Override our item with this', msg.updatedItem)
                overrideThisItem(msg.updatedItem)
              }
            }
          }
          if (msg.type === 'checkIn') {
           checkInThisItem(msg.equipmentId)
          }
        }
        })
  
      return () => {
        socket.off(`equipupdates`)
      }
  }, [rows])

  const overrideThisItem = async (updatedItem) => {
    // console.log('Override', updatedItem)
    // console.log(rows)
    let index = rows.findIndex(item => (item._id === updatedItem._id))
    console.log(index)
    if (index > -1) {
      let newRows = [
        ...rows
      ]
      newRows[index] = updatedItem
      // console.log('Updated rows...', newRows)
      setRows(newRows)
      filterOut(newRows, searchValue)
    }
  }

  const checkInThisItem = async (itemId) => {
    // console.log('Check In this guy', itemId)
    // console.log(rows)
    let index = rows.findIndex(item => (item._id === itemId))
    console.log(index)
    if (index > -1) {
      let newRows = [
        ...rows
      ]
      const updatedItem = {
        ...rows[index],
        isCheckedOut: false,
        checkedOutTo: null,
        checkedOutToName: '',
        lastCheckInTime: new Date(),
        crew: null,
        crweName: ''
      }
      newRows[index] = updatedItem
      // console.log('Updated Rows', newRows)
      setRows(newRows)
      filterOut(newRows, searchValue)
    }
  }

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
  // console.log('Set order by property: ' + property + ' in ' + isDesc + ' order')
    setOrderBy(property);
  };

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n._id);
      // console.log(newSelecteds)
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  // const handleClick = (event, name) => {
  //   const selectedIndex = selected.indexOf(name);
  // // console.log('handle click ', name)
  // // console.log('Index: ', selectedIndex)
  //   let newSelected = [];

  //   if (selectedIndex === -1) {
  //     newSelected = newSelected.concat(selected, name);
  //   } else if (selectedIndex === 0) {
  //     newSelected = newSelected.concat(selected.slice(1));
  //   } else if (selectedIndex === selected.length - 1) {
  //     newSelected = newSelected.concat(selected.slice(0, -1));
  //   } else if (selectedIndex > 0) {
  //     newSelected = newSelected.concat(
  //       selected.slice(0, selectedIndex),
  //       selected.slice(selectedIndex + 1),
  //     );
  //   }

  //   setSelected(newSelected);
  // };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const storeSearchMatches = (d) => {
  // console.log('Search matches: ', d)
    // setState({...state, searchMatches: d.length})
  }
  // const handleChangeDense = event => {
  //   setDense(event.target.checked);
  // };

  const isSelected = name => selected.indexOf(name) !== -1;

  const emptyRows = 0// rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const filterOut = (r, searchText) => {
  // console.log('FIlter out: %s - %s', r, searchText)
    let string = searchText
    let newArr = []
    r.filter(o => {
      // console.log('Object:  ', o)
      Object.keys(o).some(k => {
        // console.log(o[k])
        if(o[k]) {
          // console.log('OK: ', o[k])
          let str = o[k].toString().toLowerCase() 
          // console.log(str)
          if (str.includes(string.toLowerCase())) {
            // console.log('Mathc')
            return newArr.push(o)
          } else {
            return null
          }
        } else {
          return null
        }
      })
      // return newArr
    })
    // return newArr
    // console.log('Lenght: ', newArr.length)
    // console.log(newArr)
    // storeSearchMatches(newArr)
    // setsearchMatches(newArr.length)
    // return newArr
    setFilteredRows(newArr)
    // let newArr = r.filter(i => {
    //   if (i.includes('test')) return i
    // })
    // return newArr
    // return r.filter((obj)=>{
    //   return Object.keys(obj).reduce((acc, curr)=>{
    //         return acc || obj[curr] ? obj[curr].toString().toLowerCase().includes(string) : obj[curr];
    //   }, false);
    // })
  }
  const handleChange = (name) => (event) => {
    // console.log('Searching: ', event.target.value)
    setsearchValue(event.target.value)
    if (event.target.value === '') {
      setFilteredRows(rows)
    } else {
      filterOut(rows, event.target.value)
    }
    setPage(0)
  }

  const openSvcModal = (svc) => {
  // console.log('Open Equipment modal: ', svc)
    setEquipment(svc)
    setOpen(true)
    // history.replace(`/equipment/details/${svc._id}`)
  }
  
const updateFromSvcModal = (t, d) => {
// console.log('Update from service modal: ', d)
  if (t === 'closeModal') setOpen(false)
  if (t === 'update') {
    let services = rows
    // console.log('Got %d clients: ', clients.length)
    let index = services.findIndex(service =>  (service._id === d._id))
    if (index > -1) {
    // console.log('Svc already exists', index)
    // console.log(services[index])
      services[index] = d
    // console.log('Agai: ', services[index])
      // console.log(services)
      setRows(services)
      setFilteredRows(services)
    } else {
      services.push(d)
      setRows(services)
      setFilteredRows(services)
    }
    setOpen(false)
  }
}

const closeModal = () => {
  console.log('closeModal.....', history)
  setOpen(false)
  if (props.match?.params?.equipmentId) {
    window.close()
  } else {
    history.replace("/equipment")
  }
 
  // history.push({ pathname: props.location.pathname });
  // setTimeout(() => {
  //   fetchData(null, 'All')
   
  // })

};

const updateFromEquipmentModal = (d, newItem) => {
console.log('updateFromEquipmentModal', d)
  if (d === 'closeModal') {
    closeModal()
 

  }
  if (d === 'update') {
    console.log('Update this fucker', newItem)
    closeModal()
    let newRows = [...rows.map(item => (item._id.toString() === newItem._id ? newItem : item))]
    console.log('Set new rows', newRows)
    setRows(newRows)
    filterOut(newRows, searchValue)
  }

}

const setShowAllOrNot = () => {
// console.log('To Shor all or not', state)
  setsearchValue('')
  if (showAllEquipment) {
  // console.log('Gonna just show the active now')
    setShowAllEquipment(false)
    let activeClients = rows.filter(item => { return item.isActive })
    // console.log('Got %d activeClients: ', activeClients.length)
    setFilteredRows(activeClients)
    // setRows(activeClients)
  } else {
  // console.log('Show everyone')
    setShowAllEquipment(true)
    setFilteredRows(rows)
    // setRows(props.clients)
  }
  setPage(0)
}

const handleAddEquipment = () => {
// console.log('Add equipment')
  setShowNewEquipmentModal(true)
}

const updateParent = (d) => {
  if (d.equipment) {
  // console.log('Open this mother fucker!!', d)
    setEquipment(d.equipment)
    setOpen(true)
    setShowNewEquipmentModal(false)
  }
}

const handleUpdateVisibleEntity = (newEntity) => {
  // console.log('New entity', newEntity)
  fetchData(null, newEntity._id)
  fetchJobSites(null, newEntity._id)
}
  // console.log('Rows 584...', rows)
  return (
    <div className={classes.root}>
      <AddEquipmentModal updateParent={updateParent} equipment={rows} jobSites={jobSites} closeModal={() => setShowNewEquipmentModal(false)} open={showNewEquipmentModal} equipmentTypes={equipmentTypes} />
      <EquipmentModal  open={open} equipment={equipment} equipmentList={rows} jobSites={jobSites} crews={crews} updateParent={updateFromEquipmentModal} equipmentTypes={equipmentTypes} />
     <Paper className={classes.paper}>
      <Grid container style={{padding: '10px'}}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ChooseEntityComponent allowAll={true} title={'Visible Entities'} user={props.user} updateParent={handleUpdateVisibleEntity} />
          </Grid>
       </Grid>
        <Grid container style={{padding: '10px'}}>
          <Grid item lg={3} xs={6}>
          Total Equipment: {filteredRows.length}
          </Grid>
          <Grid item lg={4}>
          <Button
          variant="contained"
          // style="secondary"
          style={{ color: '#222'}}
          // className={classes.button}
          size="small"
          startIcon={<PersonAddIcon  color="primary" />}
          disabled={loading}
          // onClick={handleSnoutWeevil }
          onClick={handleAddEquipment}
          // onClick={handleDeleteService}
          // onClick={offerDeleteOption}
          // onClick={ () => { window.confirm('Are you sure you wish to delete this item?') ? handleDeleteService() : null } }
        >
          Add Equipment
        </Button> 
          </Grid>
          <Grid item lg={3} xs={6}>
              <FormControlLabel
                    control={<Checkbox checked={showAllEquipment} onChange={setShowAllOrNot} name="showInactiveEquipment" />}
                    label="Include Inactive"
                  />
          </Grid>
        </Grid>
        <Grid container style={{padding: '10px'}}>
          <Grid item lg={6} xs={6}>

            <div className={classes.search}>
                <div >
                  <SearchIcon /> Search { searchValue ? filteredRows.length > 1 ? `(${filteredRows.length} Matches)` : `(${filteredRows.length} Match)` : ''}
                </div>
                <input name="search" value={ searchValue } onChange={ handleChange('search') } type="text"></input>
              </div>
          </Grid>
          {/* <Grid item lg={6}>
          <FormControlLabel
                    control={<Checkbox checked={showAllEquipment} onChange={setShowAllOrNot} name="showAllEquipment" />}
                    label="Include Inactive"
                  />
          </Grid> */}

        </Grid>
        <div className={classes.tableWrapper} style={{margin: '10px'}}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
            options={{
              rowStyle: {height: 55}
            }}
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            {
                loading ? <div style={{ padding: 25 }} ><CircularProgress size={96} style={{ color: '#769ba2'}} /></div> : (
                 
            <TableBody >
              { stableSort(filteredRows, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  // console.log('Row map: ', row)
                  // console.log('Total rows; ', rows)
                  const isItemSelected = isSelected(row._id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  // setsearchMatches(rows.length)
                  // console.log(row)
                  return (
                    
                    <TableRow
                      hover
                      // onClick={event => handleClick(event, row._id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row._id}
                      className={classes.rowPad}
                      selected={isItemSelected}
                      style={row.isActive ? null : { backgroundColor: 'rgba(10, 10, 10, .5)', }}
                    >
                      <TableCell component="th" id={labelId} scope="row" padding="none">
                      <span className={classes.fakeLink} onClick={() => openSvcModal(row)}>{row.name ? row.name : 'Un-Named Item'}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {
                            row.number ? `(#${row.number})` : ''
                          }
                      </span>
                      {row.isCheckedOut ? <Chip style={{ marginLeft: 8, color: '#fff', background: '#21a42f', fontSize: '0.9em' }} size="small" label={ `${row.checkedOutToName}` } /> : ''}
                      </TableCell>
                      <TableCell align="left">
                        { (row.entity) ? <EntityLogo row={row} /> : null }
                      </TableCell>
                      <TableCell align="left">{ row.type } </TableCell>
                      <TableCell align="left">{row.location}</TableCell>
                      <TableCell align="left">{row.crewName}</TableCell>
                      <TableCell align="left">
                        {row.division}
                      </TableCell>
                      <TableCell align="left">
                        <EquipmentDetails data={row} />
                      </TableCell>
                      <TableCell>
                        <img src={row.pictureURL} width="50" />
                      </TableCell>
                    </TableRow>
                  );
                })
              }
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            )}
          </Table>
          { loading ?<CircularProgress style={{color: '#fff'}} size={ 16 } /> : ''}
                    
        </div>
        <TablePagination
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      {/* <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      /> */}
    </div>
  );
}

const EquipmentDetails = ({ data }) => {
// console.log('Equpiment Details', data)
  // console.log('Format it', formatPhoneNumber)
  let phoneNum = data.phoneNumber ? formatPhoneNumber(data.phoneNumber) : null
  // console.log('Phone Number:', phoneNum)
  let userName = null
  if (data && data.user && data.user._id) userName = data.user.name
  // const m
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: '0.8em', }}>
      <div>
        {
          phoneNum && <span>{phoneNum}</span>
        }
      </div>
      <div>
        {
          userName && <span>{userName}</span>
        }
      </div>
      <div>
        {
          data.fcmToken &&  <Chip style={{color: '#fff', background: '#21c40f', fontSize: '0.9em' }} size="small" label="Push Notifications" />
        }
      </div>
      <div>
        {
          data.year ? <span>
              {`${data.year} ${data.manufacturer ? data.manufacturer : ''} ${data.model ? data.model : ''}`}
            </span> : null
        }
      </div>
      <div>{ data.mileage ? `Mileage: ${data.mileage}` : null } </div>
      <div>{ data.VIN ? `VIN: ${data.VIN}` : null } </div>
      <div>{ data.status ? (
        <div>Status</div>
      ) : null } </div>
      {
        data.qrCode ? (
          <div>
            <span>
              {`QR Code: ${data.qrCode}`}
            </span> 
          </div>
        ) : null
      }
       {
        data.keyForJobSite?._id ? (
          <div>
            <div>
              {`Site Name: ${ data.keyForJobSite.name}`}
            </div>
            <div>
              {`Site Address: ${ data.keyForJobSite.address}`}
            </div>  
          </div>
        ) : null
      }
        {
        data.keyForEquipment?._id ? (
          <div>
            <span>
              {`Equipment Name: ${ data.keyForEquipment.name}`}
            </span> 
          </div>
        ) : null
      }
              {
        data.keyDetails?.length ? (
          <div>
            <span>
              {`Key Details: ${ data.keyDetails}`}
            </span> 
          </div>
        ) : null
      }
     
       
    </div>
  )
}
const EntityLogo = ({ user, row }) => {
  const classes = useStyles()
  // console.log('Get our entity logos...', user)
  // console.log('Row entiites', row)
  if (row && row.entity) {
    return (
      <div className={classes.rowContainer} >
        <div className={classes.rowImage}>
          <img alt="Logo" src={`${process.env.PUBLIC_URL}/${row.entity}_Logo.png`} style={{margin: '1px', maxWidth: 110, maxHeight: 20}} />
        </div>
      </div>
    )
  } else {
    return <div>Unassigned</div>
  }
}

// const mapStateToProps = (state) => {
//   return {
//     authenticated: state.authenticated,
//     notification: state.notification,
//     url: state.url
//   }
// }

export default EnhancedTable
// connect(mapStateToProps)(EnhancedTable)

